<template>
	<div>
		<div style="background-color: #FFFFFF;" class="arrow-img"></div>
		<div class="box">
			<img src="../../../static/no-log.png" alt="">
			<span>无账号可迁入</span>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				
			}
		},
	}
</script>

<style scoped>
	.box{
		text-align: center;
		position: absolute;
		top:50%;
		left:50%;
		transform: translate(-50%,-50%);
	}
	img{
		width: 128px;
		height: 128px;
	}
	span{
		display: block;
		font-size: 14px;
		color: #666666;
		margin-top:20px;
	}
	.arrow-img {
		width: 30px;
		height: 44px;
		position: fixed;
		left: 0px;
		top: 0px;
		z-index: 999;
	}
</style>



// WEBPACK FOOTER //
// src/view/noAccount/index.vue